import React, { useState, useEffect } from "react";
import classes from "./Journal.module.css";
import axios from "axios";
import { Form, Spinner } from "react-bootstrap";
import { BASE_URL } from '../../../../Components/Styles/API/API';
import Swal from "sweetalert2";
import crop from "../../../../Assets/repoort.png";
import verified from "../../../../Assets/verified.svg";
import { Modal } from 'react-bootstrap';
import Select from "react-select";
import RotatingLogo from '../../../../Assets/rotating-logo.png'
import { useNavigate } from "react-router-dom";
import CurrencyInput from "react-currency-input-field";

function UploadJournal({ isOpen, onClose,fetchExpenses }) {
  const [journalRows, setJournalRows] = useState([
    { account: null, account_id: "", account_code: "", description: "", direction: "", amount: "", showDropdown: false }
  ]);
   const [selectedImage, setSelectedImage] = useState('');

 
  const [balances, setBalances] = useState([]);
  const [createLoading, setCreateLoading] = useState('');
  const [selectedOptions, setSelectedOptions] = useState([]);
    const [selectedCurrency, setSelectedCurrency] = useState("");
    const [currencyOptions, setCurrencyOptions] = useState([]);
      const [bearer, setBearer] = useState('');
       const [balanceLoading, setBalanceLoading] = useState(false);
  const [reference, setReference] = useState("");
  const [loadingRef, setLoadingRef] = useState(false);
  const [transactionDate, setTransactionDate] = useState("");
  const [accounts, setAccounts] = useState([]);
  const [accountsLoading, setAccountsLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
    const navigate = useNavigate();
     const [maxDate, setMaxDate] = useState("");
      const [minDate, setMinDate] = useState("");

  const handlePrinter = () => window.print();

     const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${bearer}`
    };

     const readData = async () => {
          try {
            const value = await localStorage.getItem('userToken');
            const value1 = await localStorage.getItem('tobi');
             const current = await localStorage.getItem('currentMonth');
      
      
            if (value !== null && value.trim() !== '') {
              setBearer(value);
            }
             if (current !== null) {
          console.log(current)
          const date = new Date(current);  // Assume current is in a parsable date format
  
          // setCurrentMonth(date);
          const startOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
          const endOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);
          // Set the min and max date for the date input
  
          const formatDate = (date) => {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');  // Add leading zero
            const day = String(date.getDate()).padStart(2, '0');         // Add leading zero
            return `${year}-${month}-${day}`;
        };
          
         setMinDate(formatDate(startOfMonth));
        setMaxDate(formatDate(endOfMonth));
  
         console.log(formatDate(startOfMonth), formatDate(endOfMonth));
  
        }
             else {
              navigate('/login');
              return;
            }
  
      
          } catch (e) {
            alert('Failed to fetch the input from storage');
          }
        };
      
        useEffect(() => {
          readData();
        }, []);
    

  useEffect(() => {
    const fetchReference = async () => {
      console.log('in the Tokennssss');
      const token = localStorage.getItem("userToken");
      if (!token) return;
      setLoadingRef(true);
      try {
        const res = await axios.get(`${BASE_URL}/generate-sales-invoice-code`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        });
        if (res?.data) {
          const payload = res.data;
          const d =
            payload?.data ??
            payload?.code ??
            payload?.reference ??
            payload?.number ??
            payload?.data?.code;
          let ref = "";
          if (typeof d === "string" || typeof d === "number") {
            ref = d;
          } else if (d && typeof d === "object") {
            ref = d.code || d.reference || d.number || "";
          }
          setReference(ref ? String(ref) : "");
        }
      } catch (error) {
        console.error("Error fetching journal reference:", error);
      } finally {
        setLoadingRef(false);
      }
    };

    if (isOpen) {
      fetchReference();
    }
  }, [isOpen]);

  useEffect(() => {
    const fetchAccounts = async () => {
      const token = localStorage.getItem("userToken");
      if (!token) return;
      setAccountsLoading(true);
      try {
        const res = await axios.get(`${BASE_URL}/account/journal_accounts`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        });
        const payload = res?.data;
        let raw = payload?.data ?? payload;
        if (raw && typeof raw === "object" && Array.isArray(raw.data)) {
          raw = raw.data;
        }
        const list = Array.isArray(raw) ? raw : [];
        setAccounts(list);
      } catch (err) {
        console.error("Error fetching accounts:", err);
        setAccounts([]);
      } finally {
        setAccountsLoading(false);
      }
    };

    if (isOpen) {
      fetchAccounts();
    }
  }, [isOpen]);

     const uploadStatement = async () => {
      setBalances([]);
    setCreateLoading(true);

    try {

      const formData = new FormData();
      formData.append('file', selectedImage);
      formData.append('jv_number', reference);


      const response = await axios.post(
        `${BASE_URL}/account/upload-journal-entries`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${bearer}`
          }
        }
      );

      console.log(response, "heeee");
      setBalances(response.data.data);
      // Reset form fields
      setSelectedImage("");
      // Swal.fire({
      //   icon: 'success',
      //   title: 'Successful',
      //   text: response.data.message,
      // });
      // toast.success(response.data.message);
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
        Swal.fire({
          icon: 'error',
          title: 'Failed',
          text: JSON.stringify(error.response.data.message),
        });
      }
      console.error(error);
    } finally {
      setCreateLoading(false);
    }
  };
    useEffect(() => {
      if (selectedImage) {
        uploadStatement(selectedImage); // trigger API call
      }
    }, [selectedImage]);

  const totalDebit = balances.reduce((sum, entry) => sum + Number(entry.debit || 0), 0);
const totalCredit = balances.reduce((sum, entry) => sum + Number(entry.credit || 0), 0);

const difference = totalDebit - totalCredit;

// Format to two decimals
const formatNumber = (num) =>
  num.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  console.log(totalDebit, totalCredit);

  const addLine = () => {
    setJournalRows(prev => [
      ...prev,
      { account: null, account_id: "", account_code: "", description: "", direction: "", amount: "", showDropdown: false },
    ]);
  };

  const duplicateRow = (index) => {
    setJournalRows(prev => {
      const newRows = [...prev];
      const emptyRow = { account: null, account_id: "", account_code: "", description: "", direction: "", amount: "", showDropdown: false };
      newRows.splice(index + 1, 0, emptyRow);
      return newRows;
    });
  };

  const removeRow = (index) => {
    setJournalRows(prev => {
      if (prev.length === 1) return prev;
      return prev.filter((_, i) => i !== index);
    });
  };

  const handleChange = (index, field, value) => {
    setJournalRows(prev => {
      const newRows = [...prev];
      const row = { ...newRows[index] };

      if (field === "showDropdown") {
        row.showDropdown = value;
      } else if (field === "account") {
        row.account = value;
        row.account_id = value?.id ?? "";
        row.account_code = `${value?.gl_code ?? value?.code ?? ""} - ${value?.gl_name ?? value?.name ?? ""}`;
      } else {
        row[field] = value;
      }

      newRows[index] = row;
      return newRows;
    });
  };

  const fetchCurrency = async () => {
       
        try {
            const response = await axios.get(`${BASE_URL}/fetch-all-currencies`, { headers });
            const results = response.data?.data;
            // console.log(results, "currencis")
            const options = results.map((item) => ({
                label: item.name || item.code,
                value: item.id,
                symbol: item.symbol
            }));
        
            setCurrencyOptions(options);
        } catch (error) {
            const errorStatus = error.response?.data?.message;
            console.log(errorStatus);
          
        } finally {
            
        }
    };

     useEffect(() => {
        if (bearer) {
          fetchCurrency();
        }
      }, [bearer]);

  const handleSaveJournal = async () => {
    // Validation
    // if (
    //   !transactionDate ||
    //   journalRows.some(
    //     row =>
    //       !row.account_id ||
    //       !row.direction ||
    //       !row.amount ||
    //       !row.description
    //   )
    // ) {
    //   Swal.fire("Missing Fields", "Please fill all required fields.", "warning");
    //   return;
    // }

    const payload = {
      jv_number: reference,
      all_debit: totalDebit,
      all_credit: totalCredit,
      account_id: journalRows.map(row => row.account_id),
      direction: journalRows.map(row => row.direction),
      transaction_date: journalRows.map(() => transactionDate), // Create array of transactionDate
      description: journalRows.map(row => row.description),
      amount: journalRows.map(row => parseFloat(row.amount)),
    };

    setIsSaving(true);
    try {
      const res = await axios.post(`${BASE_URL}/journal/post-entries`, payload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("userToken")}`,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });
      Swal.fire({
        imageUrl: verified,
        title: "Success!",
        text: res.data.message || "Journal entry saved successfully!",
        confirmButtonText: "Okay",
        imageWidth: 48,
        imageHeight: 48,
        customClass: {
          title: classes.myTitle,
          popup: classes.myText,
          confirmButton: classes.myButton,
        },
        allowOutsideClick: false,
        preConfirm: () => {
          Swal.close();
        },
      });
      setJournalRows([
        {
          account: null,
          account_id: "",
          account_code: "",
          description: "",
          direction: "",
          amount: ""
        }
      ]);
      setTransactionDate("");
      onClose()
      fetchExpenses()
    } catch (error) {
      const msg = error?.response?.data?.message || "Network error";
      Swal.fire({
        imageUrl: crop,
        imageWidth: 48,
        imageHeight: 48,
        title: "Failed!",
        confirmButtonText: "Okay",
        text: JSON.stringify(msg),
        customClass: {
          title: classes.myTitle,
          popup: classes.myText,
          confirmButton: classes.myDeclineButton,
        },
        allowOutsideClick: false,
        preConfirm: () => {
          Swal.close();
        },
      });
    } finally {
      setIsSaving(false);
    }
  };

  if (!isOpen) return null;

const handleAccountChange = (selectedOption, rowIndex) => {
    setSelectedOptions((prevOptions) => {
      const updatedOptions = [...prevOptions];
      updatedOptions[rowIndex] = selectedOption;
      return updatedOptions;
    });

    const selectedChart = accounts.find((chart) => chart.id === selectedOption.value);

    if (selectedChart) {
      const updatedFormData = [...journalRows];
      updatedFormData[rowIndex].account_id = selectedChart.id;
      updatedFormData[rowIndex].account_code = selectedChart.gl_code;
      setJournalRows(updatedFormData);
    }
  };

  const handleFormChange = (index, field, value) => {
    let formattedValue = value;

    // Format the amount field
    if (field === 'amount' && value !== '') {
      formattedValue = (Number(value.replace(/\D/g, '')) || '').toLocaleString();
    }

    const updatedFormData = [...journalRows];
    updatedFormData[index][field] = formattedValue;
    setJournalRows(updatedFormData);
  };

   const handleValueChange1 = (value, index) => {
    const updatedFormData = [...journalRows];
    updatedFormData[index] = {
      ...updatedFormData[index],
      amount: value,
    };
    setJournalRows(updatedFormData);
  };




 

const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedImage(file); // just set state, don't upload here
    }
  };


const postBalances = async () => {
  // ✅ Step 1: check if a file has been uploaded and balances exist
  if (!balances.length || !balances[0]?.uuid) {
    Swal.fire({
      icon: 'error',
      title: 'No File Uploaded',
      text: 'You have not uploaded any file. Please check if your file has been uploaded before you continue.',
    });
    return; // stop the function here
  }

  // ✅ Step 2: optional check for balance mismatch
  const difference = Math.abs(totalDebit - totalCredit);
  if (difference > 0.01) {
    Swal.fire({
      icon: 'error',
      title: 'Unbalanced Journal',
      text: `Your journal is not balanced. Difference: ${difference.toFixed(2)}`,
    });
    return; // stop here
  }

  // ✅ Step 3: confirm upload
  const confirmed = await Swal.fire({
    title: 'Are you sure?',
    text: 'You are about to save this journal entry.',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Yes, save it!',
    cancelButtonText: 'No, cancel',
  });

  if (!confirmed.isConfirmed) return;

  setBalanceLoading(true);

  try {
    const response = await axios.post(
      `${BASE_URL}/account/save-journal-entries`,
      {
        total_debit: totalDebit,
        total_credit: totalCredit,
        uuid: balances[0]?.uuid,
      },
      { headers }
    );

    setBalances([]);
    setReference('');
    onClose();
    fetchExpenses();

    Swal.fire({
      icon: 'success',
      title: 'Successful',
      text: response.data.message,
    });
  } catch (error) {
    let errorMessage = 'An error occurred. Please try again.';
    if (error.response?.data?.message) {
      const msg = error.response.data.message;
      errorMessage =
        typeof msg === 'string'
          ? msg
          : Array.isArray(msg)
          ? msg.join('; ')
          : JSON.stringify(msg);
    }

    Swal.fire({
      icon: 'error',
      title: 'Failed',
      text: errorMessage,
    });
    console.error(error);
  } finally {
    setBalanceLoading(false);
  }
};



 


  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      size={null}
      backdropClassName={classes.modalBackdrop}
      dialogClassName={classes.modalDialog}
      contentClassName={classes.modalContent}
    >
      <h3 className={classes.title}>Upload Journal Entry — Excel</h3>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}>
      <p className={classes.subtitle}>
       Upload multiple journal lines (Account, Description, Debit, Credit). 
      </p>

      
                        <a href="https://account-api.patna.ng/api/v1/download-journal-entries" download>
                          <p
                            
                            className={classes.downloadJournal} >
                            Download Template
                          </p>
                        </a>
                      
</div>
      <div className={classes.topRow}>
        <div className={classes.inputGroup}>
          <label>Journal Reference</label>
          <div className={classes.refContainer}>
            {loadingRef ? (
              <div className={classes.spinnerWrapper}>
                <Spinner animation="border" size="sm" />
              </div>
            ) : (
              <input
                type="text"
                value={reference}
                readOnly
                placeholder="Fetching reference..."
              />
            )}
          </div>
        </div>
        <div className={classes.inputGroup}>
          <label>File</label>
          <Form.Control
                                    type="file"
                                    placeholder="Choose file"
                                    accept=".xlsx"
                                    style={{fontSize: 12, width: 300}}
                                    onChange={handleImageChange}

                                  />
        </div>
        <div className={classes.inputGroup}>
         {createLoading && (
                      <div className={classes.overlays}>
                        <p style={{
                          fontSize: 12,
                          color: '#000',
                          display: 'flex',
                          alignItems: 'center',
                          gap: 8
                        }}>Uploading, please wait.....</p>
                      </div>
                    )}
        </div>
      </div>
<div style={{ maxHeight: "500px", overflowY: "auto" }}>
      <table className={classes.table}>
  <thead>
    <tr>
      <th  style={{textAlign: 'left'}}>Transaction Date</th>
      <th style={{textAlign: 'left'}}>Description</th>
      <th style={{textAlign: 'left'}}>GL Code</th>
      <th style={{textAlign: 'left'}}>Cheque/Teller No.</th>
      <th style={{textAlign: 'right'}}>Debit</th>
      <th style={{textAlign: 'right'}}>Credit</th>
    </tr>
  </thead>
  <tbody>
    {balances.map((item, index) => (
                                        <tr key={index}>
                                          <td style={{fontSize: 12, textAlign: 'left'}}>
                                            {item.transaction_date}

                                          </td>
                                          <td style={{fontSize: 12,  textAlign: 'left'}}>
                                            {item.description}
                                          </td>
                                          <td style={{fontSize: 12,textAlign: 'left'}}>
                                            {item.gl_code}
                                          </td>
                                          <td style={{fontSize: 12, textAlign: 'left'}}>
                                            {item.cheque_number}
                                          </td>
                                          <td style={{ textAlign: "right", fontSize: 12}}>{parseFloat(item.debit).toLocaleString('en-US', {
                                            minimumIntegerDigits: 1,
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                          })}
                                          </td>
                                          <td style={{ textAlign: "right", fontSize: 12}}>{parseFloat(item.credit).toLocaleString('en-US', {
                                            minimumIntegerDigits: 1,
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                          })}
                                          </td>
                                        </tr>
                                      ))}
  </tbody>
</table>
</div>


      {/* <div className={classes.actionRow}>
        <button className={classes.addLineBtn} onClick={addLine}>
          + Add Line
        </button>
      </div> */}

      <div className={classes.totalRow}>
        <div className={classes.totalBox}>
          <span>Total Debit</span>
          <strong>{formatNumber(totalDebit)}</strong>
        </div>
        <div className={classes.totalBox}>
          <span>Total Credit</span>
          <strong>{formatNumber(totalCredit)}</strong>
        </div>
      </div>

      <div className={classes.footerButtons}>
        <button
          className={classes.resetBtn}
          onClick={() =>
            setJournalRows([
              { account: null, account_id: "", account_code: "", description: "", direction: "", amount: "", showDropdown: false }
            ])
          }
        >
          Reset
        </button>
        <button className={classes.printBtn} onClick={handlePrinter}>Print</button>
        <button
          className={classes.submitBtn}
          onClick={postBalances}
          disabled={balanceLoading}

        >
          {balanceLoading ? (
            <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
              <Spinner animation="border" size="sm" />
              Uploading...
            </span>
          ) : (
            "Upload Journal"
          )}
        </button>

      <button className={classes.closeBtn} onClick={onClose}>
        ×
      </button>
      </div>
        
    </Modal>
  );
}

export default UploadJournal;
